// Going from the landing page or the Big Picture page to a Big Picture map and back to the
// same place on the page: the link remembers the scroll position and marks its location state
// with LANDING_RETURN, set to the page to come back to (true for the landing page); the map's
// Big Picture chip (Layers/AreaMapLayer.js) shows Back for that state and returns with it, and
// the page (useLandingReturn) scrolls back.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const LANDING_RETURN = 'fromLanding';

// The Big Picture page (BigPicture.js): every whole-country map, with a few lines on each
export const BIG_PICTURE_PATH = '/big-picture';
const KEY = 'tms.landingScroll';

export const rememberLandingScroll = () => {
    try { sessionStorage.setItem(KEY, String(Math.round(window.scrollY))); } catch (e) { /* storage blocked */ }
};

export const useLandingReturn = () => {
    const {state} = useLocation();
    const returning = !!(state && state[LANDING_RETURN]);
    useEffect(() => {
        if (!returning) return undefined;
        let y = null;
        try { y = Number(sessionStorage.getItem(KEY)); } catch (e) { /* storage blocked */ }
        if (!y) {
            const section = document.getElementById('big-picture');
            if (section) section.scrollIntoView();
            return undefined;
        }
        // Put back once the page is tall enough (its maps draw after the first render)
        let tries = 0;
        const timer = setInterval(() => {
            tries++;
            if (document.documentElement.scrollHeight - window.innerHeight >= y || tries > 30) {
                window.scrollTo(0, y);
                clearInterval(timer);
            }
        }, 50);
        return () => clearInterval(timer);
    }, [returning]);
};
